module.exports = __webpack_public_path__ + "img/ep-fleche.2865c837.png";